<template>
  <div>
    <div class="d-flex justify-center align-center">
    <v-btn
      :class="$vuetify.breakpoint.smAndDown ? '' : 'v-size--large'"
      :block="$vuetify.breakpoint.smAndDown"
      color="success"
      @click="openDialog({
        max_per_stream_is_enabled: 0,
        max_per_user_per_stream_is_enabled: 0,
        should_redemptions_skip_request_queue: 0,
        is_user_input_required: 0,
        is_enabled: 0,
        is_vip: 0,
      })"
    >Reward erstellen</v-btn>
  </div>
    <div class="channelPointsWrapper"
         :class="{ 'mobile-wrapper': $vuetify.breakpoint.smAndDown }">
    <v-row>
      <v-col
        v-for="item in sortedRewards"
        :key="item.id"
        cols="12"
        sm="6"
        md="4"
        lg="4"
      >
        <v-card outlined >
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-h6 mb-4 reward-text-wrap">{{ item.title }}</div>
              <v-list-item-title class="text-overline mb-2 reward-text-wrap">{{ item.prompt }}</v-list-item-title>
              <v-list-item-subtitle>Reward Kosten: {{ item.cost }}</v-list-item-subtitle>
              <v-btn :color="item.is_bot_owner === 0 ? 'gray' : 'primary'"
                     dark @click="openDialog(item)">
                Belohnung bearbeiten
              </v-btn>
            </v-list-item-content>
            <v-list-item-avatar tile size="80" :color="item.bg_color">
              <img :src="getImage(item.img)" alt="Avatar" class="rewardimg">
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    </div>

    <v-dialog
      v-model="showDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              color="error"
              @click="deleteReward"
              :hidden="selectedReward.id === undefined"
            >
              Delete
            </v-btn>
            <v-btn
              color="success"
              @click="saveChanges"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-form ref="form" v-model="formValid">
          <v-container class="pa-4">
            <v-subheader>User Controls</v-subheader>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedReward.title"
                  label="Name des Rewards"
                  outlined
                  counter="45"
                  maxLength="45"
                  required
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedReward.cost"
                  label="Kosten"
                  outlined
                  type="Number"
                  required
                  :rules="rulesPositiveNumber"
                  min="1"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="selectedReward.cp_type"
                  item-text="title"
                  :items="cp_types"
                  label="Reward für:"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="selectedReward.prompt"
                  label="Beschreibung"
                  rows="1"
                  auto-grow
                  outlined
                  counter="200"
                  maxLength="200"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-switch
                  v-if="selectedReward.id"
                  v-model="selectedReward.is_paused"
                  label="Belohnung in Pause versetzen"
                  color="success"
                  :true-value="1"
                  :false-value="0"
                  hide-details
                  @change="saveSwitchState(selectedReward)"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-switch
                  v-model="selectedReward.should_redemptions_skip_request_queue"
                  label="Belohnungsanfrage überspringen"
                  color="success"
                  :true-value="1"
                  :false-value="0"
                  hide-details
                  @change="saveSwitchState(selectedReward)"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-switch
                  v-model="selectedReward.is_user_input_required"
                  label="Ist eine Usereingabe erforderlich?"
                  color="success"
                  :true-value="1"
                  :false-value="0"
                  hide-details
                  @change="saveSwitchState(selectedReward)"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-switch
                  v-model="selectedReward.is_enabled"
                  label="Belohnung ist sichtbar in den Kanalpunkten"
                  color="success"
                  :true-value="1"
                  :false-value="0"
                  hide-details
                  @change="saveSwitchState(selectedReward)"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  v-model="selectedReward.max_per_stream_is_enabled"
                  label="Maximale Einlösungen pro Stream aktivieren"
                  color="success"
                  :true-value="1"
                  :false-value="0"
                  hide-details
                  @change="saveSwitchState(selectedReward)"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedReward.max_per_stream"
                  label="Maximale Einlösungen pro Stream"
                  outlined
                  type="Number"
                  :rules="selectedReward.max_per_stream_is_enabled === 1 ? rulesPositiveNumber : []"
                  min="1"
                  :disabled="selectedReward.is_bot_owner === 0 || selectedReward.max_per_stream_is_enabled === 0"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  v-model="selectedReward.max_per_user_per_stream_is_enabled"
                  label="Maximale Einlösungen pro Stream pro User aktivieren"
                  color="success"
                  :true-value="1"
                  :false-value="0"
                  hide-details
                  @change="saveSwitchState(selectedReward)"
                  :disabled="selectedReward.is_bot_owner === 0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedReward.max_per_user_per_stream"
                  label="Maximale Einlösungen pro Stream pro User"
                  outlined
                  type="Number"
                  :rules="selectedReward.max_per_user_per_stream_is_enabled === 1 ? rulesPositiveNumber : []"
                  min="1"
                  :disabled="selectedReward.is_bot_owner === 0 || selectedReward.max_per_user_per_stream_is_enabled === 0"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="selectedReward.cp_type === 4">
                <v-text-field
                  v-model="selectedReward.cp_lpv"
                  label="Loyality Points pro Einlösung"
                  outlined
                  type="Number"
                  :rules="rulesPositiveNumber"
                  min="1"
                  :disabled="selectedReward.cp_type !== 4"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
        </v-form>
      </v-card>
      <v-snackbar
  v-model="ChannelPointsSettingsError"
  timeout="3000"
  color="red"
>
  Überprüfe die roten Felder!

  <template v-slot:actions>
    <v-btn
      color="pink"
      variant="text"
      @click="ChannelPointsSettingsError = false"
    >
      Close
    </v-btn>
  </template>
</v-snackbar>
    </v-dialog>

    <v-dialog
      v-model="showNotification"
      max-width="600"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showNotification = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Fehler!!!</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div class="text-h5 pa-12" style="color: red;">Leider kann diese Kanalpunktebelohnung
           nicht editiert werden! Der Grund dafür ist das diese
           Belohnung nicht vom Dashboard aus erstellt wurde!</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card>
        <v-card-title class="text-h5">Bist du dir sicher das diese
          Kanalpunktebelohnung gelöscht werden soll?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      dialogDelete: false,
      showDialog: false,
      selectedIndex: 0,
      reward: [],
      selectedReward: {
        id: '',
        title: '',
        prompt: '',
        is_bot_owner: '',
        cost: '',
        is_paused: '',
        should_redemptions_skip_request_queue: '',
        is_user_input_required: '',
        max_per_stream_is_enabled: '',
        max_per_stream: '',
        max_per_user_per_stream_is_enabled: '',
        max_per_user_per_stream: '',
        is_enabled: '',
        cp_lpv: '',
      },
      cp_types: [
        {
          value: 1,
          title: 'Zum zusammen Zocken',
        },
        {
          value: 2,
          title: 'Eine weitere beliebige Warteschlange',
        },
        {
          value: 3,
          title: 'Spotify Songrequest',
        },
        {
          value: 4,
          title: 'Kanalpunkte gegen Loyality Points tauschen',
        },
        // {
        //   value: 5,
        //   title: 'vipForTime',
        // },
        {
          value: 6,
          title: 'Zum Skippen des aktuellen Songs',
        },
        {
          value: 7,
          title: 'Erster des Streams Reward',
        },
      ],
      showNotification: false,
      formValid: false,
      rulesPositiveNumber: [
        (v) => !!v || 'Feld darf nicht leer sein',
        (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
        (v) => parseFloat(v) > 0 || 'Zahl muss positiv sein',
        (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
      ],
      rulesWith0: [
        (v) => (v !== null && (v) !== undefined) || 'Feld darf nicht leer sein',
        (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
        (v) => parseFloat(v) >= 0 || 'Zahl muss positiv sein',
        (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
      ],
      ChannelPointsSettingsError: false,
    };
  },
  mounted() {
    BackendService.loadRewards().then((data) => {
      this.reward = data.data;
      // console.log(this.reward);
    });
  },
  computed: {
    sortedRewards() {
      const sortedArray = this.reward.slice();
      sortedArray.sort((a, b) => {
        if (a.cost !== b.cost) {
          return a.cost - b.cost;
        }
        return a.title.localeCompare(b.title);
      });

      return sortedArray;
    },
  },
  methods: {
    getImage(img) {
      try {
        const data = JSON.parse(img);
        return data.url_1x;
      } catch (e) {
        return img;
      }
    },
    openDialog(item) {
      if (item.is_bot_owner === 0) {
        this.showNotification = true;
        return;
      }

      this.selectedReward = { ...item };
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    saveChanges() {
      if (!this.$refs.form || !this.$refs.form.validate()) {
        this.ChannelPointsSettingsError = true; // deine Flag
        return;
      }
      if (this.selectedReward.id) {
        // Item bearbeiten
        BackendService.updateReward(this.selectedReward).then((data) => {
          this.reward = data.data;
          this.showDialog = false;
        });
      } else {
        // Neues Item hinzufügen
        BackendService.createReward(this.selectedReward).then((data) => {
          this.reward = data.data;
          this.showDialog = false;
        });
      }
    },
    saveSwitchState(item) {
      if (item.is_paused) {
        this.selectedReward.is_paused = 1;
      } else {
        this.selectedReward.is_paused = 0;
      }
      if (item.is_vip) {
        this.selectedReward.is_vip = 1;
      } else {
        this.selectedReward.is_vip = 0;
      }
      if (item.is_enabled) {
        this.selectedReward.is_enabled = 1;
      } else {
        this.selectedReward.is_enabled = 0;
      }
      if (item.is_user_input_required) {
        this.selectedReward.is_user_input_required = 1;
      } else {
        this.selectedReward.is_user_input_required = 0;
      }
      if (item.max_per_user_per_stream_is_enabled) {
        this.selectedReward.max_per_user_per_stream_is_enabled = 1;
      } else {
        this.selectedReward.max_per_user_per_stream_is_enabled = 0;
      }
      if (item.max_per_stream_is_enabled) {
        this.selectedReward.max_per_stream_is_enabled = 1;
      } else {
        this.selectedReward.max_per_stream_is_enabled = 0;
      }
      if (item.should_redemptions_skip_request_queue) {
        this.selectedReward.should_redemptions_skip_request_queue = 1;
      } else {
        this.selectedReward.should_redemptions_skip_request_queue = 0;
      }
    },
    deleteReward() {
      // console.log(this.selectedReward.id);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      // console.log(this.selectedReward.id);
      // console.log('LÖSCHEN!!!');
      BackendService.deleteReward(this.selectedReward).then((data) => {
        this.dialogDelete = false;
        this.showDialog = false;
        this.reward = data.data;
      });
    },
    closeDelete() {
      // console.log(this.selectedReward.id);
      // console.log('NICHT LÖSCHEN!!!');
      this.dialogDelete = false;
    },
  },
};
</script>
<style scoped>
.channelPointsWrapper {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 20px 30px;
  overflow-x: hidden;
}

.channelPointsWrapper.mobile-wrapper {
  padding: 0 8px 16px;
}

.reward-text-wrap {
  white-space: normal;
  word-break: break-word;
}

.v-avatar.rounded-0 {
  border-radius: 4px !important;
}

.v-avatar img.rewardimg {
  width: 28px;
  height: 28px;
}

</style>
